import { Alert } from 'antd';
import { Component } from 'react';

import classes from './ErrorBoundary.module.css';

type ErrorBoundaryParams = {
  children: JSX.Element;
  componentName: string;
};

class ErrorBoundary extends Component<ErrorBoundaryParams, { hasError: boolean }> {
  constructor(props: ErrorBoundaryParams) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.log(error);
  }

  render() {
    const { hasError } = this.state;
    const { children, componentName } = this.props;

    if (hasError) {
      return (
        <div className={classes.errorBoundary}>
          <Alert className={classes.errorAlert} message="Error" description={`Unable to load ${componentName}`} type="error" showIcon />
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
